import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

interface PresalePoolDates {
  readonly presaleStart: string
  readonly presaleEnd: string
  readonly presaleReveal: string
  readonly presaleHide: string
  readonly generalSaleStart: string
}

export const presalePoolDatesToPayload = (dates: PresalePoolDates, timezone: string) => ({
  presaleStart: dates.presaleStart ? dayjs.utc(dates.presaleStart).toISOString() : undefined,
  presaleEnd: dates.presaleEnd ? dayjs.utc(dates.presaleEnd).toISOString() : undefined,
  presaleReveal: dates.presaleReveal ? dayjs.tz(dates.presaleReveal, timezone).utc().toISOString() : undefined,
  presaleHide: dates.presaleHide ? dayjs.tz(dates.presaleHide, timezone).utc().toISOString() : undefined,
  generalSaleStart: dates.generalSaleStart ? dayjs.utc(dates.generalSaleStart).toISOString() : undefined,
  timezone
})

export const rawDateToInput = (value: string | null): string => value?.slice(0, 16) ?? ''

export const utcDateToInput = (value: string | null, timezone: string): string =>
  value ? dayjs.utc(value).tz(timezone).format('YYYY-MM-DDTHH:mm') : ''
